import {
  bufferRefinementEvent,
  refinementEvent,
} from "../analytics/actions/refinementEvents";

export const reportFacetEvent = (dispatch, searchWillFollow, type, payload) =>
  dispatch(
    searchWillFollow
      ? bufferRefinementEvent(type, payload)
      : refinementEvent(type, payload),
  );
